import { useEffect, useState } from "react";
import { getWebhookList } from "../services/manage/webhook";
import { ServiceRegionType } from "../type";

export const useWebhookList = (authContext: any, region: ServiceRegionType) => {
    const [webhookList, setWebhookList] = useState<any>([]);

    useEffect(() => {
        const fetchWebhookList = async () => {
            const response = await getWebhookList(region, authContext.token);
            if (response?.result?.code === '0000') {
                setWebhookList(response.data);
            }
        };
        fetchWebhookList();
    }, [authContext.token, region]);

    const refetch = async () => {
        const response = await getWebhookList(region, authContext.token);
        if (response?.result?.code === '0000') {
            setWebhookList(response.data);
        }
    };

    return { webhookList, refetch };
}